<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import CitasHoyQueue from '../widgets/CitasHoyQueue.svelte';
  import LabQueueWidget from '../widgets/LabQueueWidget.svelte';
  import ImagenQueueWidget from '../widgets/ImagenQueueWidget.svelte';
  import EpisodiosAbiertosWidget from '../widgets/EpisodiosAbiertosWidget.svelte';
  import OpsTimeline from '../widgets/OpsTimeline.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import KpiCard from '../widgets/KpiCard.svelte';
  import { Citas, Laboratorio, Imagenologia, Episodios } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let citasHoy = $state(0);
  let labPendientes = $state(0);
  let imgPendientes = $state(0);
  let episodiosAbiertos = $state(0);

  async function cargar() {
    const dia = new Date().toISOString().slice(0, 10);
    const [citas, sol, proc, img, eps] = await Promise.all([
      Citas.listar(dia),
      Laboratorio.ordenes('SOLICITADA').catch(() => []),
      Laboratorio.ordenes('EN_PROCESO').catch(() => []),
      Imagenologia.ordenes('SOLICITADA').catch(() => []),
      Episodios.abiertos('CONSULTA_EXTERNA').catch(() => []),
    ]);
    citasHoy = citas.filter(c => c.estado !== 'CANCELADA').length;
    labPendientes = sol.length + proc.length;
    imgPendientes = img.length;
    episodiosAbiertos = eps.length;
  }

  const actions = [
    { id: 'agenda', label: 'Agenda', icon: '📅' },
    { id: 'pacientes', label: 'Pacientes', icon: '👤' },
    { id: 'expediente', label: 'Expediente CUI', icon: '📋' },
    { id: 'laboratorio', label: 'Laboratorio', icon: '🧪' },
    { id: 'imagenologia', label: 'Imagenología', icon: '🩻' },
  ];

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Atención clínica" subtitle="Agenda y colas de apoyo diagnóstico" variant="medico">
  <DashHero emoji="🩺" title="Atención clínica" subtitle="Agenda del día y colas de apoyo diagnóstico" variant="medico" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <KpiCard label="Citas hoy" value={citasHoy} tone="total" />
    <KpiCard label="Episodios abiertos" value={episodiosAbiertos} tone="brand" />
    <KpiCard label="Lab pendiente" value={labPendientes} tone="warning" />
    <KpiCard label="Imagen pend." value={imgPendientes} tone="neutral" />
  </div>

  <div class="dash-grid">
    <div class="col-6"><CitasHoyQueue limit={8} interactive /></div>
    <div class="col-6"><EpisodiosAbiertosWidget limit={10} {onNavigate} /></div>
    <div class="col-6"><LabQueueWidget limit={8} /></div>
    <div class="col-6"><ImagenQueueWidget limit={8} {onNavigate} /></div>
    <div class="col-6"><OpsTimeline limit={8} /></div>
  </div>
</DashboardLayout>
